import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

export const getAllExamTypes = async (filters = {}) => {
  const res = await axiosInstance.get(`/exam-types/all${qs(filters)}`);
  return res.data;
};

export const getExamTypeById = async (id) => {
  const res = await axiosInstance.get(`/exam-types/${id}`);
  return res.data;
};

export const createExamType = async (data) => {
  const res = await axiosInstance.post("/exam-types/create", data);
  return res.data;
};

export const updateExamType = async (id, data) => {
  const res = await axiosInstance.put(`/exam-types/update/${id}`, data);
  return res.data;
};

export const deleteExamType = async (id) => {
  const res = await axiosInstance.delete(`/exam-types/delete/${id}`);
  return res.data;
};
